const products = [
  {
    id: 1,
    name: 'ANTHIQUE',
    city: 'Sevilla',
    entryPrice: '10 euros',
    bottlePrice: '120 euros',
    premiumBottlePrice: '180 euros',
    dressCode: 'Sí',
    price: '10 euros',
    image: './assets/content/antique.jpg',
    likes: 10,
    rating: 0
  },
  {
    id: 2,
    name: 'OCCO',
    city: 'Sevilla',
    entryPrice: '15 euros',
    bottlePrice: '120 euros',
    premiumBottlePrice: '180 euros',
    dressCode: 'Sí',
    price: '9 euros',
    image: './assets/content/occo.jpg',
    likes: 0,
    rating: 0
  },
  {
    id: 3,
    name: 'BOTTOM',
    city: 'Sevilla ',
    entryPrice: '15 euros',
    bottlePrice: '120 euros',
    premiumBottlePrice: '180 euros',
    dressCode: 'Sí',
    price: '9 euros',
    image: './assets/content/bottom.png',
    likes: 0,
    rating: 0
  },
  {
    id: 4,
    name: 'UTHOPIA',
    city: 'Sevilla',
    entryPrice: '12 euros',
    bottlePrice: '100 euros',
    premiumBottlePrice: '140 euros',
    dressCode: 'No',
    price: '7 euros',
    image: './assets/content/uthopia.jpg',
    likes: 0,
    rating: 0
  },
  {
    id: 5,
    name: 'ABRIL',
    city: 'Sevilla',
    entryPrice: '15 euros',
    bottlePrice: '120 euros',
    premiumBottlePrice: '160 euros',
    dressCode: 'Sí',
    price: '9 euros',
    image: './assets/content/prueba.gif',
    likes: 0,
    rating: 0
  },
  {
    id: 6,
    name: 'Alfonso',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/alfonso.jpg',
    likes: 0,
    rating: 0
  }, 
  {
    id: 7,
    name: 'Libano',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/libano.jpg',
    likes: 0,
    rating: 0
  },
  {
    id: 8,
    name: 'B3',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/b3.jpg',
    likes: 0,
    rating: 0
  }, {
    id: 9,
    name: 'Bilindo',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/bilindo.jpg',
    likes: 0,
    rating: 0
  },
 
  {
    id: 10,
    name: 'Gran  vía',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/granVia.jpg',
    likes: 0,
    rating: 0
  },
  {
    id: 11,
    name: 'KOKO',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/koko.jpg',
    likes: 0,
    rating: 0
  },
  {
    id: 12,
    name: 'Wall Street',
    city: 'Sevilla',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/WallStreet.png',
    likes: 0,
    rating: 0
  },
  {
    id: 13,
    name: 'BLU PUERTO SHERRY',
    city: 'Cadiz',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/blu.jpg',
    likes: 0,
    rating: 0
  },
  {


    
    id: 14,
    name: 'phiphi',
    city: 'Cadiz',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/phiphi.jpg',
    likes: 0,
    rating: 0
  },
 
 
  {
    id: 15,
    name: 'playa canalla',
    city: 'Cadiz',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/playacanalla.jpg',
    likes: 0,
    rating: 0
  },
   {
    id: 16,
    name: 'padreo',
    city: 'Cadiz',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/padreo.jpg',
    likes: 0,
    rating: 0
  },
   
   {
    id: 17,
    name: 'Margarita',
    city: 'Cadiz',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/margarita.jpg',
    likes: 0,
    rating: 0
  },


  {
    id: 18,
    name: 'Guateque',
    city: 'Cadiz',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/guateque.jpg',
    likes: 0,
    rating: 0
  },

  {
    id: 19,
    name: 'playa Aruba',
    city: 'Malaga',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/Aruba.jpg',
    likes: 0,
    rating: 0
  },

  {
    id: 20,
    name: 'Momento ',
    city: 'Malaga',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/momento.jpg',
    likes: 0,
    rating: 0
  },

  {
    id: 21,
    name: 'taboo ',
    city: 'Malaga',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/taboo.jpg',
    likes: 0,
    rating: 0
  },


   {
    id: 22,
    name: 'fitz ',
    city: 'Malaga',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/fitz.jpg',
    likes: 0,
    rating: 0
  },

   {
    id: 23,
    name: 'bless ',
    city: 'Malaga',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/bless.jpg',
    likes: 0,
    rating: 0
  },


     {
    id: 24,
    name: 'olivia valere ',
    city: 'Malaga',
    entryPrice: '18 euros',
    bottlePrice: '150 euros',
    premiumBottlePrice: '200 euros',
    dressCode: 'Sí',
    price: '12 euros',
    image: './assets/content/olivia valere.jpg',
    likes: 0,
    rating: 0
  },
];
// 👇 fetchProducts SIN duplicar productos con id 50, 51, 52
export const fetchProducts = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(products);
    }, 1000); // Simula un retraso de 1 segundo
  });
};

export const likeProduct = (productId) => {
  const product = products.find(p => p.id === productId);
  if (product) {
    product.likes += 1;
  }
  return product;
};

export const dislikeProduct = (productId) => {
  const product = products.find(p => p.id === productId);
  if (product && product.likes > 0) {
    product.likes -= 1;
  }
  return product;
};

export const voteProduct = (productId, rating) => {
  const product = products.find(p => p.id === productId);
  if (product) {
    product.rating = rating;
  }
  return product;
};

export const getTopRatedProducts = () => {
  return products.sort((a, b) => b.rating - a.rating);
};

export const getProductSummary = (productId) => {
  const product = products.find(p => p.id === productId);
  if (product) {
    return `${product.name} in ${product.city} with entry price of ${product.entryPrice}`;
  }
  return null;
};
